import {
    CREATE_USER,
    CREATE_USER_FAIL,
    CREATE_USER_SUCCESS
} from './actionTypes';

export const createUser = userToCreate => ({
    type: CREATE_USER,
    payload: userToCreate
});

export const createUserSuccess = userCreated => ({
    type: CREATE_USER_SUCCESS,
    payload: userCreated
});

export const createUserFail = error => ({
    type: CREATE_USER_FAIL,
    payload: error
});
